import script from "./Rightside.vue?vue&type=script&setup=true&lang=ts"
export * from "./Rightside.vue?vue&type=script&setup=true&lang=ts"

import "./Rightside.vue?vue&type=style&index=0&id=76a1299b&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76a1299b"]])

export default __exports__